import { createReducer, on } from '@ngrx/store';
import * as complianceActions from '../actions/compliance.actions';
import { IComplianceResponse } from '../models/compliance.model';

export const complianceFeatureKey = 'compliance';

export interface ComplianceState {
  loading: boolean;
  data: IComplianceResponse[] | null;
  error: any;
}

export const initialState: ComplianceState = {
  loading: false,
  data: null,
  error: null
};

export const reducer = createReducer(
  initialState,
  on(complianceActions.loadComplianceRequest, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.loadComplianceSuccess, (state, { response }) => ({ ...state, loading: false, data: response })),
  on(complianceActions.loadComplianceFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(complianceActions.addCompliance, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.addComplianceSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    data: state.data ? [...state.data, response] : [response],
    error: null
  })),
  on(complianceActions.addComplianceFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(complianceActions.updateCompliance, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.updateComplianceSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    data: state.data ? state.data.map(item => item.userProfileComplianceId === response.userProfileComplianceId ? response : item) : [response],
    error: null
  })),
  on(complianceActions.updateComplianceFailure, (state, { error }) => ({ ...state, loading: false, error }))
);